document.addEventListener("DOMContentLoaded", function() {
    let addOnProductsElements = document.querySelectorAll('add-on-products');

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let lazyImages = entry.target.querySelectorAll('.lazy-load');
                lazyImages.forEach(image => {
                    image.style.backgroundImage = `url(${image.getAttribute('data-src')})`;
                });
                observer.unobserve(entry.target);
            }
        });
    }, options);

    addOnProductsElements.forEach(addOnProducts => {
        observer.observe(addOnProducts);
    });
});
